import he from 'he'
import { escape, kebabCase } from 'lodash'

export function handleStyleConfig(config, defaultConfig) {
  const style = Object.assign({}, defaultConfig, config)
  return Object.keys(style)
    .map(key => {
      return kebabCase(key) + ':' + style[key]
    })
    .join(';')
}

export function getParagraphHtml(content, config) {
  const styleStr = handleStyleConfig(config, {
    fontSize: '16px',
    lineHeight: '1.5',
    textIndent: '2em'
  })
  return `<p class="section-paragraph" style="${styleStr}">${content}</p>`
}

/**
 * 使用区域块包裹内容
 * @param title
 * @param level
 * @param htmlString
 * @param needMarginLeft 是否需要左侧缩进
 * @param titleStyle 标题样式
 * @param sectionStyle 区块容器样式
 * @returns {string}
 */
export function sectionHtmlWrapper({
  title = '',
  level = 1,
  htmlString = '',
  needMarginLeft = true,
  titleStyle = {},
  sectionStyle = {}
}) {
  const titleStyleStr = handleStyleConfig(titleStyle, {
    fontSize: 20 - level * 2
  })
  const sectionTitle = title
    ? `
  <div class="section-title" style="${titleStyleStr}">
   ${title}
  </div>
  `
    : ''
  const sectionMarginLeft = needMarginLeft ? 10 * (level - 1) : 0
  const sectionStyleStr = handleStyleConfig(sectionStyle, {
    marginLeft: sectionMarginLeft + 'px'
  })
  return `<div class="section" style="${sectionStyleStr}">
      ${sectionTitle}
      <div class="section-content" style="margin-top: 10px">
        ${htmlString}
      </div>
   </div>
  `
}

/**
 * 用page标签包裹表格html字符串
 * (每一个单独被page包裹的页面，都可以单独占一页)
 * @param pdfTitle {String} 单页标题
 * @param contentString {String} 内容html模板
 * @param pagedHeader {Object} content: 内容， style：样式
 * @param pageFooter {Object} content: 内容， style：样式
 */
export function pageWrapper({ pageTitle, htmlString }) {
  const pageTitleHtml = pageTitle
    ? `<h1 style="text-align: center">${escape(pageTitle)}</h1>`
    : ''

  return `
  <div class="page">
      ${pageTitleHtml}
      ${htmlString}
    </div>
  `
}

/**
 * 用html包裹表格body字符串
 * @param {String} htmlString  body的html字符串
 * @param {String} pdfTitle  网页标题
 * @param {horizontal|vertical} dircetion 默认horizontal
 * @param {Object} pageSettingObj 页面页脚设置({ key: content }) key为页面位置，content为内容；如{ top-left: '页面左上角内容' }
 * @param {String} bodyFontSize body的字体大小，默认10px
 */
export function htmlWrapper({
  htmlString,
  pdfTitle,
  direction = 'horizontal',
  pageSettingObj = {},
  bodyFontSize = '12px'
}) {
  const pageSettingStr = Object.keys(pageSettingObj)
    .map(key => {
      return `@${key}{
      content: ${pageSettingObj[key]};
      font-family: SimSun;
      font-size: 12px;
      color: #000;
    }`
    })
    .join(' ')

  return `
<!DOCTYPE html>
<html lang="zh_CN">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${he.encode(pdfTitle || '')}</title>

    <style>
      @page {
        ${direction === 'horizontal' ? 'size: A4 landscape;' : 'size: A4;'}

        @bottom-center {
          content: "第" counter(page) "页/共 " counter(pages) "页";
          font-family: SimSun;
          font-size: 12px;
          color: #000;
        }
        ${pageSettingStr}
      }

      body {
        margin: 0;
        padding: 0;
        font-family: SimSun !important;
        font-size: ${bodyFontSize};
      }

      span {
        font-family: SimSun !important;
      }

      .m-t-16 {
        margin-top: 16px;
      }

      .m-t-24 {
        margin-top: 24px;
      }

      /*页面样式*/
      .page {
        page-break-after: always;
      }
      .page:last-child {
        page-break-after: auto;
      }

      .content {
        margin-bottom: 16px;
      }
      .content:last-child {
        margin-bottom: 0;
      }


      .project {
        width: 100%;
        display: table;
        margin-bottom: 8px;
      }
      .project .project-item {
        text-align: left;
        display: table-cell;
      }
      .project::after {
        content: "";
        display: inline-block;
        height: 0;
        width: 100%;
      }

      /*表格样式*/
      .table, table {
        width: 100% !important;
      }
      th,tr,td,tfoot {
        page-break-inside: avoid;
      }
      
      td {
        border: 1px solid #000 !important;
      }
      
      img {
        max-width: 100%;
      }

      /*区块样式*/
      .section + .section {
        margin-top: 20px;
      }
    </style>
  </head>
  <body>
    ${htmlString}
  </body>
</html>
`
}

export const getJxicReportHtmlWrapper = ({ htmlString }) => {
  return `
  <!DOCTYPE html>
<html lang="zh_CN">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>自动化报告</title>

    <style>
      @page {
        size: A4;

        @bottom-right {
          content: counter(page);
          font-family: FangSong_GB2312;
          font-size: 12px;
          color: #000;
        }
      }

      body {
        margin: 0;
        padding: 0;
        font-family: FangSong_GB2312 !important;
        font-size: 16px;
      }

      span {
        font-family: FangSong_GB2312 !important;
      }

      .m-t-16 {
        margin-top: 16px;
      }

      .m-t-24 {
        margin-top: 24px;
      }

      /*页面样式*/
      .page {
        page-break-after: always;
      }
      .page:last-child {
        page-break-after: auto;
      }

      .content {
        margin-bottom: 16px;
      }
      .content:last-child {
        margin-bottom: 0;
      }
      
      p {
        margin: 0;
      }


      .project {
        width: 100%;
        display: table;
        margin-bottom: 8px;
      }
      .project .project-item {
        text-align: left;
        display: table-cell;
      }
      .project::after {
        content: "";
        display: inline-block;
        height: 0;
        width: 100%;
      }

      /*表格样式*/
      .table {
        width: 100%;
      }
      th,tr,td,tfoot {
        page-break-inside: avoid;
      }

    </style>
  </head>
  <body>
    ${htmlString}
  </body>
</html>
  `
}
